<template>
  <div class="app" :class="{ hidden: !Visible }">
    <transition-group name="fade">
      <Loader key="Loader" v-if="Loading" />
      <div
        class="app__selector"
        :class="{ dark: DarkMode.Live }"
        key="App"
        v-else
      >
        <Modal />
        <Toast :aplicacion="aplicacion" />
        <div class="app__selector__header">
          <Pdf
            :viewprice="viewprice === 'true'"
            style="
              position: absolute;
              z-index: 1000000000;
              height: 100dvh;
              width: 100dvw;
              visibility: hidden;
            "
            :aplicacion="aplicacion"
            :Coleccion="aplicacion.coleccionSel"
            :Language="aplicacion.languageSel"
            :token="token"
            :privada="privada"
            @setPdf="setPdf"
            :pdf="pdf"
          />
          <Header
            :aplicacion="aplicacion"
            :aplicacionEstandar="aplicacionEstandar"
            :aplicacionConfigurable="aplicacionConfigurable"
            :Language="aplicacion.languageSel"
            :Coleccion="aplicacion.coleccionSel"
            :Options="Options"
            :privada="privada"
            @Share="SetShare"
            :DarkMode="DarkMode"
            @DarkMode="SetDarkMode"
            :Hotspots="Hotspots"
            @Hotspots="SetHotspots"
            :FullScreen="FullScreen"
            @FullScreen="SetFullScreen"
            @Close="SetClose"
            @Comparador="SetComparador"
            :Zoom="Zoom"
            @Zoom="SetZoom"
          />
        </div>
        <div class="app__selector__content">
          <Pricing
            v-if="viewprice === 'true'"
            :aplicacion="aplicacion"
            :bloquearpedidos="bloquearpedidos === 'true'"
            :sideSel="aplicacion.coleccionSel.sideSel.Live"
            :token="token"
            :privada="privada"
          />
          <Canvas
            v-if="aplicacion.view.Delay == '2d'"
            class="app__selector__content__canvas"
            :class="{
              hidden: aplicacion.view.Live == '3d',
            }"
            :aplicacion="aplicacion"
            :Open="Open"
            :Comparador="Comparador"
            :Zoom="Zoom"
            :Hotspots="Hotspots.Live"
            :Version="Version"
            @Side="SetSide"
            @Grupo="SetGrupo"
            @Comparador="SetComparador"
          />
          <Pano
            class="app__selector__content__pano"
            v-else
            :class="{
              hidden: aplicacion.view.Live == '2d',
            }"
          />
          <Buttons
            :aplicacion="aplicacion"
            :Language="aplicacion.languageSel"
            :Open="Open"
            @Open="SetOpen"
            :Buttons="Buttons"
            :Content="Content"
            @Content="SetContent"
            :Comparador="Comparador"
            @Comparador="SetComparador"
            :Zoom="Zoom"
            @Zoom="SetZoom"
            @Hotspots="SetHotspots"
            @View="SetView"
            :Version="Version"
            :DarkMode="DarkMode"
            @setPdf="setPdf"
            :pdf="pdf"
          />
          <Menu
            :Open="Open"
            :Content="Content"
            :aplicacion="aplicacion"
            :unSoloTipo="unSoloTipo"
            :privada="privada"
            @Close="SetClose"
            @Grupo="SetGrupo"
            @Filtro="SetFiltro"
            @Acabado="SetAcabado"
            @AcabadoCompuesto="SetAcabadoCompuesto"
            @Save="SetSave"
            @Type="SetType"
          />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";

import Loader from "@/components/Loader.vue";
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import Toast from "@/components/Toast.vue";
import Pricing from "@/components/Pricing.vue";
import Canvas from "@/components/Canvas.vue";
import Pano from "@/components/Pano.vue";
import Buttons from "@/components/Buttons.vue";
import Menu from "@/components/Menu.vue";
import Pdf from "@/components/Pdf.vue";

import Aplicacion from "@/clases/Aplicacion.js";
import Coleccion from "@/clases/Coleccion.js";
import Side from "@/clases/Side.js";
import Campo from "@/clases/Campo.js";
import Grupo from "@/clases/Grupo.js";
import Acabado from "@/clases/Acabado.js";
import Filtro from "@/clases/Filtro.js";
import Literal from "@/clases/Literal.js";
import Position from "@/clases/Position.js";
import Datos3Drender from "@/clases/Datos3Drender.js";

export default {
  name: "App",
  components: {
    Loader,
    Header,
    Modal,
    Toast,
    Pricing,
    Canvas,
    Pano,
    Buttons,
    Menu,
    Pdf,
  },
  data() {
    return {
      pdf: false,
      Version: new String(),
      Visible: false,
      Loading: true,
      Open: false,
      Content: "",
      Comparador: false,
      Zoom: false,
      Buttons: [
        {
          cod: "montaje",
          miniatura: "Global/Taladro.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Montaje",
            },
            {
              codIdioma: "en",
              texto: "Assembly",
            },
            {
              codIdioma: "fr",
              texto: "Montage",
            },
            {
              codIdioma: "de",
              texto: "Montage",
            },
            {
              codIdioma: "it",
              texto: "Montaggio",
            },
            {
              codIdioma: "pt",
              texto: "Montagem",
            },
          ],
        },
        {
          cod: "download",
          miniatura: "Global/PDFDownload.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Imprimir configuración",
            },
            {
              codIdioma: "en",
              texto: "Print settings",
            },
            {
              codIdioma: "fr",
              texto: "Imprimer les paramètres",
            },
            {
              codIdioma: "de",
              texto: "Druckeinstellungen",
            },
            {
              codIdioma: "it",
              texto: "Impostazioni di stampa",
            },
            {
              codIdioma: "pt",
              texto: "",
            },
          ],
        },
        {
          cod: "detalles",
          miniatura: "Global/Add.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Detalles",
            },
            {
              codIdioma: "en",
              texto: "Details",
            },
            {
              codIdioma: "fr",
              texto: "Détails",
            },
            {
              codIdioma: "de",
              texto: "Details",
            },
            {
              codIdioma: "it",
              texto: "Dettagli",
            },
            {
              codIdioma: "pt",
              texto: "Detalhes",
            },
          ],
        },
        {
          cod: "caracteristicas",
          miniatura: "Global/Caracteristicas.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Configuración",
            },
            {
              codIdioma: "en",
              texto: "Settings",
            },
            {
              codIdioma: "fr",
              texto: "Paramètres",
            },
            {
              codIdioma: "de",
              texto: "Einstellungen",
            },
            {
              codIdioma: "it",
              texto: "Impostazioni",
            },
            {
              codIdioma: "pt",
              texto: "Configurações",
            },
          ],
        },
        {
          cod: "resumen",
          miniatura: "Global/Resumen.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Resumen",
            },

            {
              codIdioma: "en",
              texto: "Summary",
            },
            {
              codIdioma: "fr",
              texto: "Résumé",
            },
            {
              codIdioma: "de",
              texto: "Zusammenfassung",
            },
            {
              codIdioma: "it",
              texto: "Riepilogo",
            },
            {
              codIdioma: "pt",
              texto: "Resumo",
            },
          ],
        },
        {
          cod: "favorites",
          miniatura: "Global/Favorites.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Configuraciones guardadas",
            },

            {
              codIdioma: "en",
              texto: "Saved configurations",
            },
            {
              codIdioma: "fr",
              texto: "Paramètres enregistrés",
            },
            {
              codIdioma: "de",
              texto: "Gespeicherte Einstellungen",
            },
            {
              codIdioma: "it",
              texto: "Impostazioni salvate",
            },
            {
              codIdioma: "pt",
              texto: "Configurações salvas",
            },
          ],
        },
        {
          cod: "zoom",
          miniatura: "Global/Zoom.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Zoom",
            },
            {
              codIdioma: "en",
              texto: "Zoom",
            },
            {
              codIdioma: "fr",
              texto: "Zoom",
            },
            {
              codIdioma: "de",
              texto: "Zoom",
            },
            {
              codIdioma: "it",
              texto: "Zoom",
            },
            {
              codIdioma: "pt",
              texto: "Zoom",
            },
          ],
        },
        {
          cod: "comparador",
          miniatura: "Global/Comparador.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Comparador",
            },
            {
              codIdioma: "en",
              texto: "Comparator",
            },
            {
              codIdioma: "fr",
              texto: "Comparateur",
            },
            {
              codIdioma: "de",
              texto: "Vergleicher",
            },
            {
              codIdioma: "it",
              texto: "Comparatore",
            },
            {
              codIdioma: "pt",
              texto: "Comparador",
            },
          ],
        },
        {
          cod: "view",
          miniatura: ["Global/2D.svg", "Global/360.svg"],
          literales: [
            {
              codIdioma: "es",
              texto: ["Visualización 360°", "Visualización fija"],
            },
            {
              codIdioma: "en",
              texto: ["360° Visualization", "Fixed Visualization"],
            },
            {
              codIdioma: "fr",
              texto: ["Visualisation 360°,", "Visualisation fixe"],
            },
            {
              codIdioma: "de",
              texto: ["360°-Ansicht", "Feste Ansicht"],
            },
            {
              codIdioma: "it",
              texto: ["Visualizzazione 360°", "Visualizzazione fissa"],
            },
            {
              codIdioma: "pt",
              texto: ["Visualização 360°", "Visualização fixa"],
            },
          ],
        },
        {
          cod: "cerrar",
          miniatura: "Global/Cerrar.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Cerrar",
            },
            {
              codIdioma: "en",
              texto: "Close",
            },
            {
              codIdioma: "fr",
              texto: "Fermer",
            },
            {
              codIdioma: "de",
              texto: "Schließen",
            },
            {
              codIdioma: "it",
              texto: "Chiudi",
            },
            {
              codIdioma: "pt",
              texto: "Fechar",
            },
          ],
        },
      ],
      DarkMode: {
        Live: false,
        Delay: false,
      },
      Hotspots: {
        Live: true,
        Delay: true,
      },
      FullScreen: {
        Live: false,
        Delay: false,
      },
      Options: [
        {
          cod: "Share",
          miniatura: "Global/Share.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Compartir configuración",
            },

            {
              codIdioma: "en",
              texto: "Share configuration",
            },
            {
              codIdioma: "fr",
              texto: "Partager la configuration",
            },
            {
              codIdioma: "de",
              texto: "Konfiguration teilen",
            },
            {
              codIdioma: "it",
              texto: "Condividi configurazione",
            },
            {
              codIdioma: "pt",
              texto: "Compartilhar configuração",
            },
          ],
        },
        {
          cod: "DarkMode",
          miniatura: ["Global/DarkMode.svg", "Global/LightMode.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Modo oscuro",
                },
                {
                  codIdioma: "en",
                  texto: "Dark mode",
                },
                {
                  codIdioma: "fr",
                  texto: "Mode sombre",
                },
                {
                  codIdioma: "de",
                  texto: "Dunkelmodus",
                },
                {
                  codIdioma: "it",
                  texto: "Modalità scura",
                },
                {
                  codIdioma: "pt",
                  texto: "Modo escuro",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Modo claro",
                },
                {
                  codIdioma: "en",
                  texto: "Light mode",
                },
                {
                  codIdioma: "fr",
                  texto: "Mode clair",
                },
                {
                  codIdioma: "de",
                  texto: "Hellmodus",
                },
                {
                  codIdioma: "it",
                  texto: "Modalità chiara",
                },
                {
                  codIdioma: "pt",
                  texto: "Modo claro",
                },
              ],
            },
          ],
        },
        {
          cod: "Hotspots",
          miniatura: ["Global/HotspotOFF.svg", "Global/HotspotON.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Ocultar puntos calientes",
                },
                {
                  codIdioma: "en",
                  texto: "Hide hotspots",
                },
                {
                  codIdioma: "fr",
                  texto: "Masquer les points chauds",
                },
                {
                  codIdioma: "de",
                  texto: "Heiße Punkte ausblenden",
                },
                {
                  codIdioma: "it",
                  texto: "Nascondi punti caldi",
                },
                {
                  codIdioma: "pt",
                  texto: "Ocultar pontos quentes",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Mostrar puntos calientes",
                },
                {
                  codIdioma: "en",
                  texto: "Show hotspots",
                },
                {
                  codIdioma: "fr",
                  texto: "Afficher les points chauds",
                },
                {
                  codIdioma: "de",
                  texto: "Heiße Punkte anzeigen",
                },
                {
                  codIdioma: "it",
                  texto: "Mostra punti caldi",
                },
                {
                  codIdioma: "pt",
                  texto: "Mostrar pontos quentes",
                },
              ],
            },
          ],
        },
        {
          cod: "FullScreen",
          miniatura: ["Global/FullScreen.svg", "Global/FullScreenOFF.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Pantalla completa",
                },
                {
                  codIdioma: "en",
                  texto: "Full screen",
                },
                {
                  codIdioma: "fr",
                  texto: "Plein écran",
                },
                {
                  codIdioma: "de",
                  texto: "Vollbild",
                },
                {
                  codIdioma: "it",
                  texto: "Schermo intero",
                },
                {
                  codIdioma: "pt",
                  texto: "Tela cheia",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Salir de pantalla completa",
                },
                {
                  codIdioma: "en",
                  texto: "Exit full screen",
                },
                {
                  codIdioma: "fr",
                  texto: "Quitter le mode plein écran",
                },
                {
                  codIdioma: "de",
                  texto: "Vollbild verlassen",
                },
                {
                  codIdioma: "it",
                  texto: "Uscire dalla modalità a schermo intero",
                },
                {
                  codIdioma: "pt",
                  texto: "Sair do modo de tela cheia",
                },
              ],
            },
          ],
        },
      ],
      separador: "&",
      separador2: "-",
      extension: "webp",
      datosConfigurable: new Object(),
      datosEstandar: new Object(),
      datos3Drender: {},
      unSoloTipo: false,
      aplicacion: new Object(),
      aplicacionEstandar: new Object(),
      aplicacionConfigurable: new Object(),
      languages: ["1", "2", "3", "4", "5", "6"],
      language: "",
      eventReady: null,
      codImage: "",
      montaje: 0,
    };
  },
  props: {
    bloquearpedidos: { type: String, default: "false" },
    viewprice: { type: String, default: "true" },
    token: new String(),
    idclase: new String(),
    idmaterial: new String(),
    idcoleccion: new String(),
    locale: new String(),
    inicial: new String(),
    idcliente: new String(),
    perfil: new Object(),
    privada: new String(),
    ficha: new String(),
    video: new String(),
    manual: new String(),
  },
  mounted() {
    // Crea el evento de ready
    this.eventReady = new CustomEvent("3drender-ready", {
      detail: {
        status: true,
      },
    });
    window.addEventListener("3drender-ready", function (event) {
      //console.log("Evento: 3drender-ready");
    });

    if (window.location.href.includes("8081")) {
      this.SetWorkAround();
      this.GetDatos3Drender();
    } else {
      this.SetAplicacion();
    }
    this.SetVersion();
    this.GetLS();
    setTimeout(() => {
      console.log(this.bloquearpedidos);
      console.log(this.viewprice);
      console.log(typeof this.bloquearpedidos);
      console.log(typeof this.viewprice);
      window.dispatchEvent(this.eventReady);
    }, 2500);
  },
  methods: {
    setPdf(bool) {
      this.pdf = bool;
    },
    // CONSTRUCCION DE LOS OBJETOS APLICACION
    SetAplicacion() {
      var that = this;

      document.addEventListener("3drender-open-modal", function (event) {
        if (
          event.detail.idMaterial != null &&
          event.detail.idMaterial != undefined &&
          event.detail.idMaterial != ""
        ) {
          // Modificamos el prop, no se debe hacer pero sólo es este cambio
          that.montaje = event.detail.montaje ?? undefined;
          that.idmaterial = event.detail.idMaterial;
        }
        if (event.detail.perfil != undefined && event.detail.perfil != null) {
          if (Object.keys(event.detail.perfil).length > 0) {
            // Modificamos el prop, no se debe hacer pero sólo es este cambio
            that.perfil = event.detail.perfil;

            that.montaje = event.detail.perfil.montaje;
          }
        }

        that.SetDatos();
      });
    },
    SetWorkAround() {
      this.token =
        "ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SnlaVzVrWlhKeklqcDBjblZsTENKamJHbGxiblJsSWpvaU1qTTNPRE1pTENKd2NtbDJZV1J2SWpwMGNuVmxMQ0psZUhBaU9qazVPVGs1T1RrNU9UbDkueElfcnZvTGdkVjdDVVgtZWY3cmx6RDdERXJCdDl0MUl5aGVMQUpiMVVKQQ==";
      this.idcliente = "27934";
      // this.idclase = prompt("Insertar idclase:", "");
      // this.idmaterial = prompt("Insertar material:", "SEN01SC0002");
      // this.idcoleccion = prompt("Insertar idcoleccion:", "SEN");
      // this.inicial = prompt("inicial:", "estandar");
      // this.idclase = "BAGDAD";
      // this.idmaterial = "";
      // this.idcoleccion = "";

      this.idclase = "MINDANAO";
      this.idmaterial = "MIN01CR00";
      this.idcoleccion = "MIN";

      //this.idclase = "";
      //this.idmaterial = "FLD01SC0002HL";
      //this.idcoleccion = "FLD";
      // this.idclase = "QUITO";
      // this.idmaterial = "QUI01SC0002";
      // this.idcoleccion = "QUITO";
      // this.idclase = "RODAS";
      // this.idmaterial = "";
      // this.idcoleccion = "";
      // this.idclase = "RIMINI";
      // this.idmaterial = "";
      // this.idcoleccion = "";

      // this.descripcion = "descripcion";
      // this.coleccion = "coleccion";

      this.inicial = "configurable";
      this.locale = "1";
      this.privada = "false";
      this.montaje = 2;
      this.SetDatos();
    },
    SetDatosEstandar() {
      var that = this;
      var config = {
        method: "get",
        maxBodyLength: Infinity,
        url:
          "https://clients.docciagroup.com/api/renders/coleccion?coleccion=" +
          this.idcoleccion +
          "&lng=" +
          this.locale,
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };

      axios
        .request(config)
        .then((response) => {
          that.datosEstandar = response.data;
          // Fija el idioma de la app
          that.language = that.datos3Drender.language[0][that.locale];
          that.IniciaAplicacion();
        })
        .catch((error) => {
          //console.log("Error al llamar al servicio de colección", error);
          // Inicia la aplicación, por si puede cargar el configurable
          that.datosEstandar = {};
          that.IniciaAplicacion();
        });
    },
    SetDatos() {
      if (!this.languages.includes(this.locale)) {
        this.locale = "2";
      }

      document.documentElement.style.overflow = "hidden";
      this.$root.$emit("Loader");
      window.scrollTo(0, 0);
      this.Visible = true;

      // Inicializa los datos extendidos
      this.datos3Drender = new Datos3Drender();

      var config;
      var that = this;
      // Llega el parámetro para configurable
      if (
        this.idclase != "" &&
        this.idclase != undefined &&
        this.idclase != null
      ) {
        config = {
          method: "get",
          maxBodyLength: Infinity,
          url:
            "https://clients.docciagroup.com/api/renders/configurable?codigo=" +
            that.idclase.toUpperCase() +
            "&lng=" +
            that.locale,
          headers: {
            Authorization: "Bearer " + that.token,
          },
        };

        axios
          .request(config)
          .then((response) => {
            // Fija el idioma de la app
            that.language = that.datos3Drender.language[0][that.locale];

            // Datos
            that.datosConfigurable = response.data;

            if (that.datosConfigurable.code == 0) {
              that.datosConfigurable = {};
            } else {
              that.datosConfigurable = response.data;
            }

            // Comprueba si debe cargar los datos de colección
            if (that.idcoleccion != null && that.idcoleccion != "") {
              // Carga los datos de colección (estándar)

              this.SetDatosEstandar();
            } else {
              // No hay que cargar la colección

              this.IniciaAplicacion();
            }
          })
          .catch((error) => {
            //console.log("Error al llamar al servicio configurable", error);
            // Carga los datos de colección (estándar)
            that.datosConfigurable = {};

            this.SetDatosEstandar();
          });
      } else {
        this.datosConfigurable = {};
        // var lineas = this.datos3Drender.colecciones.filter(
        //   (linea) => linea.idcoleccion == that.idcoleccion
        // );
        // if (lineas.length == 1) {
        //   this.idclase = lineas[0].idclase;
        // }
        // Carga los datos de colección (estándar)

        this.SetDatosEstandar();
      }

      // Idclase
      if (this.idclase != null && this.idclase != "") {
        let lineas = this.datos3Drender.colecciones.filter(
          (linea) => linea.idcoleccion == this.idclase.toUpperCase()
        );
        if (lineas.length == 1) {
          this.codImage = lineas[0].idclase;
        } else {
          this.codImage = this.idclase.toUpperCase();
        }
      } else if (this.idcoleccion != null && this.idcoleccion != "") {
        let lineas = this.datos3Drender.colecciones.filter(
          (linea) => linea.idcoleccion == this.idcoleccion.toUpperCase()
        );

        if (lineas.length == 1) {
          this.codImage = lineas[0].idclase;
        } else {
          this.codImage = this.idcoleccion.toUpperCase();
        }
      }
    },
    IniciaAplicacion() {
      var bool;
      this.privada == "true"
        ? (bool = true)
        : Object.keys(this.datosConfigurable).length > 0 &&
          Object.keys(this.datosEstandar).length > 0
        ? (bool = false)
        : (bool = true);
      this.unSoloTipo = bool;
      if (Object.keys(this.datosConfigurable).length == 0) {
        ////console.log("No puede obtener datos configurables");
        //return -1;
      }

      // Determina si debe abrir estándar o configurable según esta preferencia:
      // 1.- parámetro "inicial" en la URL
      // 2.- prop "inicial" del evento de inicio
      const url = new URL(window.location.href);
      var inicial = url.searchParams.get("inicial");
      if (inicial != "estandar" && inicial != "configurable") {
        if (this.inicial == "estandar" || this.inicial == "configurable") {
          inicial = this.inicial;
        } else {
          inicial = "estandar";
        }
      }

      // Determina si puede arrancar la app como se le pide
      if (
        inicial == "configurable" &&
        Object.keys(this.datosConfigurable).length == 0
      ) {
        //console.log("No puede arrancar la aplicación configurable");
        return -2;
      }
      if (
        inicial == "estandar" &&
        Object.keys(this.datosEstandar).length == 0
      ) {
        //console.log("No puede arrancar la aplicación estándar");
        return -3;
      }

      //console.log("this.datosEstandar", this.datosEstandar);
      //console.log("this.datosConfigurable", this.datosConfigurable);

      // Crea las aplicaciones (estándar, configurable o ambas)
      if (Object.keys(this.datosConfigurable).length > 0) {
        this.aplicacionConfigurable = this.CreaConfigurable();
        // Actualiza perfil si viene en el prop
        this.aplicacionConfigurable.colecciones[0].sides[0].perfil =
          this.UpdatePerfil(
            this.aplicacionConfigurable.colecciones[0].sides[0],
            this.aplicacionConfigurable.colecciones[0].sides[0].perfil
          );
        this.aplicacionConfigurable.colecciones[0].sides[0].perfil =
          this.UpdatePerfilURL(
            this.aplicacionConfigurable.colecciones[0].sides[0],
            this.aplicacionConfigurable.colecciones[0].sides[0].perfil
          );

        this.aplicacionConfigurable.colecciones[0].codImage = this.codImage;

        //console.log(
        //   "codImage Configurable",
        //   this.aplicacionConfigurable.colecciones[0].codImage
        // );
      }
      if (Object.keys(this.datosEstandar).length > 0) {
        this.aplicacionEstandar = this.CreaEstandar();

        this.aplicacionEstandar.colecciones[0].codImage = this.codImage;

        //console.log(
        //   "codImage Estándar",
        //   this.aplicacionEstandar.colecciones[0].codImage
        // );
      }
      if (inicial == "configurable") {
        this.aplicacion = this.aplicacionConfigurable;
      } else {
        this.aplicacion = this.aplicacionEstandar;
      }

      // Oculta los parámetros de la url
      window.history.replaceState(null, "", url.origin + url.pathname);

      setTimeout(() => {
        this.Loading = false;
      }, 2700);
    },
    SetSide(Side) {
      // Siempre hace el cambio de side, aunque el side no haya cambiado,
      // de esta forma se puede forzar un "refresh"
      if (this.Content == "resumen") {
        var Resumen;
        if (window.location.href.includes("8081")) {
          Resumen = document.getElementsByClassName("menu__resumen__grupos")[0];
        } else {
          Resumen = document
            .querySelector("c-selector")
            .shadowRoot.querySelector(".menu__resumen__grupos");
        }
        Resumen.style.opacity = 0;
        this.aplicacion.coleccionSel.sideSel.Live = Side;
        this.aplicacion.grupoSel.Live = Side.GetGrupo(
          this.aplicacion.grupoSel.Live.cod
        );
        setTimeout(() => {
          this.aplicacion.coleccionSel.sideSel.Delay = Side;
          this.aplicacion.grupoSel.Delay = Side.GetGrupo(
            this.aplicacion.grupoSel.Delay.cod
          );
          Resumen.style.opacity = 1;
        }, 350);
      } else {
        this.aplicacion.coleccionSel.sideSel.Live = Side;
        this.aplicacion.grupoSel.Live = Side.GetGrupo(
          this.aplicacion.grupoSel.Live.cod
        );
        this.aplicacion.coleccionSel.sideSel.Delay = Side;
        this.aplicacion.grupoSel.Delay = Side.GetGrupo(
          this.aplicacion.grupoSel.Delay.cod
        );
      }
    },
    CopiaSide(side) {
      var sideRet;

      sideRet = new Side();
      // Crea perfil
      var perfil = this.CreaPerfil(side);
      sideRet.perfil = perfil[0];
      sideRet.perfilRevestimiento = perfil[1];

      // Reset del array de grupos
      sideRet.grupos = new Array();

      var grupoR;
      var campoR;
      var acabadoR;

      for (let i = 0; i < side.grupos.length; i++) {
        grupoR = new Grupo();
        grupoR = Object.assign(grupoR, side.grupos[i]);
        grupoR.position = new Position();
        grupoR.position.left = side.grupos[i].position.left;
        grupoR.position.top = side.grupos[i].position.top;
        sideRet.grupos[i] = grupoR;

        // Reset del array de campos
        grupoR.campos = new Array();
        for (let j = 0; j < side.grupos[i].campos.length; j++) {
          campoR = new Campo();
          campoR = Object.assign(campoR, side.grupos[i].campos[j]);
          sideRet.grupos[i].campos[j] = campoR;
          // Reset del array de acabados
          campoR.acabados = new Array();
          // Campo compuesto
          if (side.grupos[i].campos[j].compuesto != undefined) {
            campoR.compuesto = new Campo();
            campoR.compuesto = sideRet.GetCampo(
              side.grupos[i].campos[j].compuesto.cod
            );
          }

          // Filtros
          var filtroR;
          if (side.grupos[i].campos[j].filtros != undefined) {
            campoR.filtros = new Array();
            for (let k = 0; k < side.grupos[i].campos[j].filtros.length; k++) {
              filtroR = new Filtro();
              filtroR = Object.assign(
                filtroR,
                side.grupos[i].campos[j].filtros[k]
              );
              filtroR.acabados = new Array();
              for (
                let l = 0;
                l < side.grupos[i].campos[j].filtros[k].acabados.length;
                l++
              ) {
                acabadoR = new Acabado();
                acabadoR = Object.assign(
                  acabadoR,
                  side.grupos[i].campos[j].filtros[k].acabados[l]
                );
                filtroR.acabados.push(acabadoR);
              }
              filtroR.acabadoSel == filtroR.acabados[0];
              campoR.filtros.push(filtroR);
            }
            campoR.filtroSel.Live = campoR.filtros[0];
            campoR.filtroSel.Delay = campoR.filtros[0];
          }

          // Acabados
          for (let k = 0; k < side.grupos[i].campos[j].acabados.length; k++) {
            acabadoR = new Acabado();
            acabadoR = Object.assign(
              acabadoR,
              side.grupos[i].campos[j].acabados[k]
            );
            sideRet.grupos[i].campos[j].acabados[k] = acabadoR;
          }

          // AcabadoSel
          if (side.grupos[i].campos[j].acabadoSel != undefined) {
            sideRet.grupos[i].campos[j].acabadoSel = sideRet.grupos[i].campos[
              j
            ].GetAcabado(sideRet.grupos[i].campos[j].acabadoSel.cod);
          }
        }
      }
      // Campo compuesto en el acabado.Se hace en una segunda pasada para que los campos estén creados
      for (let i = 0; i < side.grupos.length; i++) {
        for (let j = 0; j < side.grupos[i].campos.length; j++) {
          // Campo compuesto
          if (side.grupos[i].campos[j].compuesto != undefined) {
            campoR = new Campo();
            campoR = sideRet.GetCampo(side.grupos[i].campos[j].compuesto.cod);
            sideRet.grupos[i].campos[j].compuesto = campoR;
          }
          // Acabados
          for (let k = 0; k < side.grupos[i].campos[j].acabados.length; k++) {
            if (side.grupos[i].campos[j].acabados[k].compuesto != undefined) {
              acabadoR.compuesto = new Campo();
              acabadoR.compuesto = sideRet.GetCampo(
                side.grupos[i].campos[j].acabados[k].compuesto.cod
              );
            }
          }
        }
      }
      return sideRet;
    },
    CreaLiteral(texto) {
      var literal = new Literal();
      literal.codIdioma = this.language;
      literal.texto = texto;
      return literal;
    },
    CreaLiteralIdioma(codIdioma, texto) {
      var literal = new Literal();
      literal.codIdioma = codIdioma;
      literal.texto = texto;
      return literal;
    },
    CreaPerfil(side) {
      var perfil = {};
      var perfilRevestimiento = {};

      if (this.perfil != undefined && this.perfil != null) {
        // HARCODE PARA EL CASO DE ADELAIDA. Está con acabado acrílico, por tanto no está informado el tipo de vidrio, pero
        // casi todas las condiciones llevan tipode vidrio y fallan.
        if (this.perfil.tipo_vidrio == undefined) {
          this.perfil.tipo_vidrio = { value: "01" };
        }
        perfil = { ...this.perfil };
        //console.log("El perfil se carga");
        //console.log(perfil);
      } else {
        side.grupos.forEach((grupo) => {
          if (grupo.cod != "REVESTIMIENTO") {
            // Perfil normal
            grupo.campos.forEach((campo) => {
              if (campo.acabadoSel != undefined) {
                perfil[campo.cod.toLowerCase()] = {
                  value: campo.acabadoSel.cod,
                };
              } else {
                perfil[campo.cod.toLowerCase()] = { value: campo.value };
              }
            });
          }
        });
      }
      // Añade el perfil de revestimiento
      side.grupos.forEach((grupo) => {
        if (grupo.cod == "REVESTIMIENTO") {
          // El revestimiento tiene su perfil propio para poder pasarlo como parámetro
          grupo.campos.forEach((campo) => {
            perfilRevestimiento[campo.cod.toLowerCase()] = {
              value: campo.acabadoSel.cod,
            };
          });
        }
      });
      // Algunas condiciones tienen la expresión  perfil.material == ... debe retornar false
      perfil.material = { value: this.idmaterial };
      if (
        this.idcliente == undefined ||
        this.idcliente == "" ||
        this.idcliente == null
      ) {
        perfil.cliente = { value: 27934 };
      } else {
        perfil.cliente = { value: this.idcliente };
      }
      perfil.clase_pedido = {
        value: "ZWEB",
      };
      perfil.lateral_fijo = {
        value: "0",
      };
      return [perfil, perfilRevestimiento];
    },
    UpdatePerfil(side, perfil) {
      if (
        this.perfil == "" ||
        this.perfil == undefined ||
        this.perfil == null
      ) {
        return perfil;
      } else {
        perfil = this.perfil;
        // Aplicar el perfil al objeto aplicacion
        ////console.log("=========================================");
        for (const atributo in perfil) {
          if (perfil.hasOwnProperty(atributo)) {
            const valor = perfil[atributo].value;
            ////console.log(`${atributo}: ${valor}`);
            let campo = side.GetCampo(atributo.toUpperCase());
            if (campo != undefined) {
              if (campo.acabadoSel != undefined) {
                campo.acabadoSel = campo.GetAcabado(valor);
              } else {
                campo.value = valor;
              }
            } else {
              ////console.log(atributo, "No existe como característica");
            }
          }
        }
        return perfil;
      }
    },
    UpdatePerfilURL(side, perfil) {
      // var perfil = {};
      var perfilRevestimiento = {};

      // Mira si el perfil viene como parámetro de URL
      const url = new URL(window.location.href);
      const perfilParam = url.searchParams.get("perfil");
      const perfilRevestimientoParam = url.searchParams.get(
        "perfilRevestimiento"
      );
      if (perfilParam != undefined) {
        perfil = JSON.parse(perfilParam);
        perfilRevestimiento = JSON.parse(perfilRevestimientoParam);
        side.grupos.forEach((grupo) => {
          if (grupo.cod == "REVESTIMIENTO") {
            grupo.campos.forEach((campo) => {
              campo.acabadoSel = campo.GetAcabado(
                perfilRevestimiento[campo.cod.toLowerCase()].value
              );
            });
          } else {
            grupo.campos.forEach((campo) => {
              if (campo.acabadoSel != undefined) {
                campo.acabadoSel = campo.GetAcabado(
                  perfil[campo.cod.toLowerCase()].value
                );
              } else {
                campo.value = perfil[campo.cod.toLowerCase()].value;
              }
            });
          }
        });
      }

      return perfil;
    },
    CreaConfigurable() {
      var coleccionCod = this.idclase;
      var datos3Drender = this.datos3Drender;
      var datosConfigurable = this.datosConfigurable;

      var aplicacion, coleccion, side, grupo, campo, acabado;
      var caracteristicas;
      var valores;
      var that = this;

      // Crea el objeto aplicacion
      aplicacion = new Aplicacion();
      aplicacion.cod = "app";
      aplicacion.ficha = this.ficha;
      aplicacion.manual = this.manual;
      aplicacion.video = this.video;
      aplicacion.tipo = "configurable";
      aplicacion.languageSel = this.language;
      aplicacion.literales.push(this.CreaLiteral("app"));

      // Se carga una sola colección
      coleccion = aplicacion.colecciones[0] = new Coleccion();

      // Datos de colección
      coleccion.cod = coleccionCod.toLowerCase();

      if (this.datosConfigurable.descripcion != undefined) {
        coleccion.literales.push(
          this.CreaLiteral(this.datosConfigurable.descripcion)
        );
      } else {
        coleccion.literales.push(this.CreaLiteral(coleccionCod));
      }

      var objectPosition = that.datos3Drender.objectPosition.filter(
        (linea) => linea.coleccion == this.idclase.toUpperCase()
      );

      if (objectPosition.length >= 1) {
        coleccion.objectPosition = {
          open: objectPosition[0].open * 100 + "%",
          close: objectPosition[0].close * 100 + "%",
        };
      } else {
        coleccion.objectPosition = {
          open: "revert",
          close: "revert",
        };
      }

      //Determina que Colecciones contienen Pano 360
      var ColeccionesPermitidas = ["quito"];
      if (ColeccionesPermitidas.includes(coleccion.cod)) {
        coleccion.pano = true;
      }

      // Sólo nos llega una colección, la coleccionSel será la primera
      aplicacion.coleccionSel = coleccion;

      // Se crea el side 0, luego se duplicará el side 1
      side = new Side();
      side.cod = "left";
      side.id = 0;

      // El side seleccionado es el de la izquierda
      coleccion.sideSel.Live = side;
      coleccion.sideSel.Delay = side;

      // Se rellena el objeto aplicación
      caracteristicas = datosConfigurable.caracteristicas;

      // Debug
      let mensajeAntes = [];
      caracteristicas.forEach((caracteristica) => {
        mensajeAntes.push({
          codigo: caracteristica.codigo,
          descripcion: caracteristica.descripcion,
          condicion: caracteristica.condicion,
          defecto: caracteristica.valorPorDefecto,
        });
      });
      mensajeAntes.sort((a, b) => a.codigo - b.codigo);

      caracteristicas = caracteristicas.filter(
        (caracteristica) =>
          caracteristica.codigo != "MATERIAL_PADRE" &&
          caracteristica.codigo != "COLOR_POMO_ST"
      );

      let mensajeDespues = [];
      caracteristicas.forEach((caracteristica) => {
        mensajeDespues.push({
          codigo: caracteristica.codigo,
          descripcion: caracteristica.descripcion,
          condicion: caracteristica.condicion,
          defecto: caracteristica.valorPorDefecto,
        });
      });
      mensajeDespues.sort((a, b) => a.codigo - b.codigo);

      // Calcular diferencia entre mensajeAntes y mensajeDespues
      const diferenciaAntes = mensajeAntes.filter(
        (itemAntes) =>
          !mensajeDespues.some(
            (itemDespues) =>
              itemDespues.codigo === itemAntes.codigo &&
              itemDespues.condicion === itemAntes.condicion &&
              itemDespues.defecto === itemAntes.defecto
          )
      );

      caracteristicas.forEach((caracteristica) => {
        campo = new Campo();
        campo.ayuda = caracteristica.ayuda;
        campo.literales.push(this.CreaLiteral(caracteristica.descripcion));

        // Se añade el campo
        // El COLOR_PERFIL se transforma en COLOR_PERFIL_ST para no replicar código
        // Al pedir el precio se vuelve a transformar
        if (caracteristica.codigo == "COLOR_PERFIL") {
          campo.cod = "COLOR_PERFIL_ST";
        } else if (caracteristica.codigo == "POMO") {
          campo.cod = "POMO_ST";
        } else {
          campo.cod = caracteristica.codigo;
        }

        campo.id = caracteristica.id;
        campo.condicion = caracteristica.condicion;
        campo.relacion = caracteristica.relacion;
        campo.visible = true;

        if (caracteristica.precios) {
          campo.precios = caracteristica.precios;
        }

        // Se asigna el campo a un grupo a la vez que crea el grupo si es necesario
        grupo = this.CreaCamposGrupos(side, campo);
        grupo.campos.push(campo);
        // Si no tiene valores es tipo input
        // Si tiene valores y es visual es de tipo lista
        // Si tiene valores y NO es visual es dropdown

        if (
          caracteristica.valores != undefined &&
          caracteristica.valores != ""
        ) {
          valores = caracteristica.valores;
          if (campo.visual) {
            campo.tipo = "tacos";
          } else {
            campo.tipo = "dropdown";
          }
          valores.forEach((valor) => {
            acabado = new Acabado();
            acabado.cod = valor.valor;
            acabado.id = valor.id;
            acabado.literales.push(this.CreaLiteral(valor.descripcion));
            acabado.relacion = valor.relacion;
            acabado.condicion = valor.condicion;
            acabado.taco =
              campo.cod + this.separador + acabado.cod + "." + this.extension;
            campo.acabados.push(acabado);
          });
          campo.acabadoSel = campo.GetAcabado(caracteristica.valorPorDefecto);
        } else {
          campo.acabadoSel = undefined;
          campo.tipo = "input";
          campo.value = caracteristica.valorPorDefecto;
          campo.medida = caracteristica.medida;
        }

        // Si está especificado el tipo en datos3Drender tiene prioridad, se machaca
        let filtro = datos3Drender.tipoCampo.filter(
          (linea) => linea.campo == caracteristica.codigo
        );
        if (filtro.length > 0) {
          campo.tipo = filtro[0].tipo;
          // Los toggle deben llevar sólo 2 valores, si no se convierten a dropdown
          if (campo.tipo == "toggle" && campo.acabados.length != 2) {
            campo.tipo = "dropdown";
          }
        }
        // Orden del tipo de vidrio
        if (campo.cod == "TIPO_VIDRIO") {
          campo.acabados = campo.acabados.sort(function (a, b) {
            if (a.cod == "04") {
              return 1; // Si a es 3, lo mueve al final
            } else if (b.cod == "04") {
              return -1; // Si b es 3, lo mantiene en su posición actual
            } else {
              return 0; // Para otros valores, no cambia el orden
            }
          });
        }
        // Desactiva Lateral fijo
        if (campo.cod == "LATERAL_FIJO") {
          campo.visible = false;
        }

        if (campo.cod == "ACABADO" || campo.cod == "ACRILICO") {
          campo.tipo = "dropdown";
          campo.visual = true;
        }
        if (
          coleccion.cod.toUpperCase() == "MINDANAO" &&
          campo.cod == "OPCIONES_MINDANAO"
        ) {
          campo.tipo = "dropdown";
          campo.visual = true;
          campo.esCapa = false;
        }
      });

      // Crea los grupos adicionales y otros por si no los ha creado, si están vacíos no saldrán
      grupo = side.GetGrupo(side, "OTROS");
      if (grupo == undefined) {
        grupo = this.NuevoGrupo(side, "OTROS");
      }
      grupo = side.GetGrupo(side, "ADICIONALES");
      if (grupo == undefined) {
        grupo = this.NuevoGrupo(side, "ADICIONALES");
      }

      // Se añade el grupo de Revestimientos en el side
      grupo = this.NuevoGrupo(side, "REVESTIMIENTO");
      this.CreaRevestimiento(coleccion, grupo);

      // El grupo seleccionado se asigna a aplicacion y es el primero del sideSel
      aplicacion.grupoSel.Live = coleccion.sideSel.Live.grupos[0];
      aplicacion.grupoSel.Delay = coleccion.sideSel.Live.grupos[0];

      // HARDCODE 1: Campos compuestos, acabados compuestos, filtros y modal
      // Añade los campos compuestos, filtros y modal
      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // Campos cuya imagen está compuesta con otro campo
          if (campo.cod == "POMO_ST") {
            campo.compuesto = side.GetCampo("COLOR_PERFIL_ST");
          }

          if (campo.cod == "DECORADO") {
            let campoCompuesto = side.GetCampo("COLOR_DECORADO");
            if (campoCompuesto == undefined) {
              campoCompuesto = new Campo();
              campoCompuesto.id = null;
              campoCompuesto.condicion =
                "(perfil.tipo_vidrio.value == '04' || perfil.tipo_vidrio.value == '12') && perfil.acabado.value == '1'";
              campoCompuesto.relacion = "";
              campoCompuesto.literales.push(this.CreaLiteral("COLOR_DECORADO"));
              campoCompuesto.cod = "COLOR_DECORADO";
              campoCompuesto.visible = true;
              campoCompuesto.tipo = "tacos";
              let acabado = new Acabado();
              acabado.cod = "01";
              acabado.id = null;
              acabado.literales.push(this.CreaLiteral("BLANCO"));
              acabado.relacion = "";
              acabado.condicion = "";
              acabado.taco =
                campoCompuesto.cod +
                this.separador +
                acabado.cod +
                "." +
                this.extension;
              campoCompuesto.acabados.push(acabado);
              campoCompuesto.acabadoSel = acabado;
              grupo.campos.push(campoCompuesto);
            }
            campo.compuesto = campoCompuesto;
          }
          // Modal

          if (
            campo.cod == "COLOR_PERFIL_ST" ||
            campo.cod == "POMO_ST" ||
            campo.cod == "PERFIL_ESCUADRA" ||
            campo.cod == "SISTEMA_SUJECCION" ||
            campo.cod == "PERFILERIA_ECO"
          ) {
            campo.acabados.forEach((acabado) => {
              if (acabado.cod != "RL") {
                acabado.modal = true;
              }
            });
          }
        });
      });
      // Filtros
      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // Filtros
          if (campo.cod == "COLOR_DECORADO") {
            campo.esCapa = false;
            campo.tipo = "filtro";
            // Crea los filtros
            campo.filtros = new Array();
            var campoFiltro = side.GetCampo("DECORADO");
            campo.campoFiltro = campoFiltro;
            campoFiltro.visible = false;
            campo.literales = [];
            campoFiltro.literales.forEach((literal) => {
              campo.literales.push(
                this.CreaLiteralIdioma(literal.codIdioma, literal.texto)
              );
            });
            campo.ayuda = campoFiltro.ayuda;

            var acabadoAux;
            var filtro;
            campo.acabados.forEach((acabado) => {
              filtro = new Filtro();
              filtro.cod = acabado.cod;
              filtro.literales = new Array();
              acabado.literales.forEach((literal) => {
                filtro.literales.push(
                  this.CreaLiteralIdioma(literal.codIdioma, literal.texto)
                );
              });
              campo.filtros.push(filtro);
              filtro.acabados = new Array();
              campoFiltro.acabados.forEach((acabadoFiltro) => {
                acabadoAux = new Acabado();
                acabadoAux = Object.assign(acabadoAux, acabadoFiltro);
                acabadoAux.taco =
                  campoFiltro.cod +
                  this.separador2 +
                  campo.cod +
                  this.separador +
                  acabadoAux.cod +
                  this.separador2 +
                  acabado.cod +
                  "." +
                  this.extension;
                filtro.acabados.push(acabadoAux);
              });
              filtro.acabadoSel = filtro.GetAcabado(campoFiltro.acabadoSel.cod);
            });
            campo.filtroSel.Live = campo.GetFiltro(campo.acabadoSel.cod);
            campo.filtroSel.Delay = campo.GetFiltro(campo.acabadoSel.cod);
          }
        });
      });

      // Añade acabados compuestos
      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // Campos cuya imagen está compuesta por los acabados de otros campos
          if (campo.cod == "TIPO_VIDRIO") {
            campo.acabados.forEach((acabado) => {
              if (acabado.cod != "MC") {
                acabado.compuesto = side.GetCampo("PARED");
              } else {
                acabado.compuesto = side.GetCampo("SUELO");
              }
            });
          }
          if (campo.cod == "ACRILICO") {
            campo.acabados.forEach((acabado) => {
              if (acabado.cod != "MC") {
                acabado.compuesto = side.GetCampo("PARED");
              } else {
                acabado.compuesto = side.GetCampo("SUELO");
              }
            });
          }
        });
      });
      // HARDCODE 1: Campos compuestos, acabados compuestos, filtros y modal

      // Ordena los campos dentro de los grupos, primero no visual
      side.grupos.forEach((grupo) => {
        grupo.campos.sort(function (a, b) {
          return a.visual - b.visual;
        });
      });

      // Ordena los grupos
      side.grupos.sort((a, b) => a.orden - b.orden);

      // Crea los literales
      side.literales.push(this.CreaLiteral("Izquierda"));
      // Crea perfil o coge el del prop. Sólo se aplica al side izda, el side dcha se queda con el perfil por defecto
      let perfiles;
      perfiles = this.CreaPerfil(side);
      side.perfil = perfiles[0];
      side.perfilRevestimiento = perfiles[1];
      // Se añaden los sides a la colección
      coleccion.sides.push(side);
      coleccion.sides.push(this.CopiaSide(side));
      // Se cambia el código e id
      coleccion.sides[1].cod = "right";
      coleccion.sides[1].id = 1;
      coleccion.sides[1].literales = [];
      coleccion.sides[1].literales.push(this.CreaLiteral("Derecha"));

      aplicacion.datos3Drender = this.datos3Drender;
      aplicacion.datosEstandar = this.datosEstandar;
      aplicacion.datosConfigurable = this.datosConfigurable;

      return aplicacion;
    },
    CreaEstandar() {
      var aplicacion, coleccion, side, grupo, campo, acabado;
      var caracteristicas, codigos;

      // ATENCIÓN los códigos de colección deben ser los de configurable por las imágenes.
      // Qué pasa si no llega idclase? -> está hardcodeado al inicio
      var coleccionCod = this.idcoleccion;

      // Relación entre códigos de campo estándar y a medida
      var corresp = this.datos3Drender.estandar;
      var lineaDefecto = this.datosEstandar.codigos.filter(
        (linea) => linea.codigo == this.idmaterial
      );
      if (lineaDefecto.length == 0) {
        lineaDefecto = this.datosEstandar.codigos[0];
      } else {
        lineaDefecto = lineaDefecto[0];
      }

      // Crea el objeto aplicacion
      aplicacion = new Aplicacion();
      aplicacion.cod = "app";
      aplicacion.ficha = this.ficha;
      aplicacion.manual = this.manual;
      aplicacion.video = this.video;
      aplicacion.tipo = "estandar";
      aplicacion.languageSel = this.language;
      aplicacion.literales.push(this.CreaLiteral("app"));

      // Se carga una sola colección
      coleccion = aplicacion.colecciones[0] = new Coleccion();

      // Datos de colección
      coleccion.cod = coleccionCod.toLowerCase();

      // El nombre va en cualquiera de los códigos estándar
      if (
        this.datosEstandar.codigos[0].coleccion != undefined &&
        this.datosEstandar.codigos[0].coleccion != null &&
        this.datosEstandar.codigos[0].coleccion != ""
      ) {
        coleccion.literales.push(
          this.CreaLiteral(this.datosEstandar.codigos[0].coleccion)
        );
      } else {
        coleccion.literales.push(this.CreaLiteral(coleccionCod));
      }

      var objectPosition = this.datos3Drender.objectPosition.filter(
        (linea) => linea.coleccion == this.idclase.toUpperCase()
      );

      if (objectPosition.length >= 1) {
        coleccion.objectPosition = {
          open: objectPosition[0].open * 100 + "%",
          close: objectPosition[0].close * 100 + "%",
        };
      } else {
        coleccion.objectPosition = {
          open: "revert",
          close: "revert",
        };
      }

      //Determina que Colecciones contienen Pano 360
      var ColeccionesPermitidas = ["quito"];
      if (ColeccionesPermitidas.includes(coleccion.cod)) {
        coleccion.pano = true;
      }

      // Sólo nos llega una colección, la coleccionSel será la primera
      aplicacion.coleccionSel = coleccion;

      // Se crea el side 0, luego se duplicará el side 1
      side = new Side();
      side.cod = "left";
      side.id = 0;

      // El side seleccionado es el de la izquierda
      coleccion.sideSel.Live = side;
      coleccion.sideSel.Delay = side;

      // Se rellena el objeto aplicación
      caracteristicas = this.datosEstandar.caracteristicas;
      codigos = this.datosEstandar.codigos;

      var campoCod, relacion, caracteristica;

      for (const clave in caracteristicas) {
        if (caracteristicas.hasOwnProperty(clave)) {
          caracteristica = caracteristicas[clave];
          campoCod = clave;
          relacion = corresp.filter((linea) => linea.estandar == clave);

          campo = new Campo();
          if (caracteristica.precios) {
            campo.precios = caracteristica.precios;
          }
          campo.ayuda = null;
          campo.literales.push(this.CreaLiteral(caracteristica.etiqueta));
          campo.cod = campoCod;
          campo.id = null;
          campo.visible = true;

          // Se asigna el campo a un grupo a la vez que crea el grupo si es necesario
          grupo = this.CreaCamposGrupos(side, campo);
          grupo.campos.push(campo);
          if (
            caracteristica.valores != undefined &&
            caracteristica.valores.length > 0
          ) {
            caracteristica.valores.forEach((valor) => {
              acabado = new Acabado();
              acabado.cod = valor.value;

              acabado.literales.push(this.CreaLiteral(valor.text));
              // Sólo tiene capas si es campo visual
              if (campo.visual) {
                campo.tipo = "tacos";
              } else {
                campo.tipo = "dropdown";
              }
              campo.acabados.push(acabado);
              if (lineaDefecto[campo.cod] == acabado.cod) {
                campo.acabadoSel = campo.GetAcabado(acabado.cod);
              }
            });
            // Si no lo encuentra por error se pone el primero
            if (campo.acabadoSel == undefined) {
              campo.acabadoSel = campo.acabados[0];
            }
          } else {
            // En este caso el campo sólo puede ser posicionFijo y significa que no debe aparecer
            // Se añade 1 acabado con código = 0 y se lo ponemos a acabadoSel, es necesario para que no
            // de error y por no tener un valor de acabado
            campo.tipo = "dropdown";
            acabado = new Acabado();
            acabado.cod = "0";
            acabado.literales.push(this.CreaLiteral("0"));
            campo.acabados.push(acabado);
            campo.acabadoSel = acabado;
            campo.visible = true;
          }

          // Modal
          if (campo.cod == "perfil" || campo.cod == "tirador") {
            campo.acabados.forEach((acabado) => {
              if (acabado.cod != "RL") {
                acabado.modal = true;
              }
            });
          }

          if (campo.cod == "montaje" && this.montaje) {
            campo.acabadoSel = campo.GetAcabado(this.montaje);
          }
        }
      }

      // Crea los grupos adicionales y otros por si no los ha creado, si están vacíos no saldrán
      grupo = side.GetGrupo(side, "OTROS");
      if (grupo == undefined) {
        grupo = this.NuevoGrupo(side, "OTROS");
      }
      grupo = side.GetGrupo(side, "ADICIONALES");
      if (grupo == undefined) {
        grupo = this.NuevoGrupo(side, "ADICIONALES");
      }

      // Se añade el grupo de Revestimientos en el side
      grupo = this.NuevoGrupo(side, "REVESTIMIENTO");
      this.CreaRevestimiento(coleccion, grupo);

      // El grupo seleccionado se asigna a aplicacion y es el primero del sideSel
      aplicacion.grupoSel.Live = coleccion.sideSel.Live.grupos[0];
      aplicacion.grupoSel.Delay = coleccion.sideSel.Live.grupos[0];

      // Añade campos compuestos.
      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // Campos cuya imagen está compuesta con otro campo
          if (campo.cod == "tirador") {
            campo.compuesto = side.GetCampo("perfil");
          }
        });
      });

      // Añade acabados compuestos
      side.grupos.forEach((grupo) => {
        grupo.campos.forEach((campo) => {
          // Campos cuya imagen está compuesta por los acabados de otros campos
          if (campo.cod == "vidrio") {
            campo.acabados.forEach((acabado) => {
              if (acabado.cod != "MC") {
                acabado.compuesto = side.GetCampo("PARED");
              } else {
                acabado.compuesto = side.GetCampo("SUELO");
              }
            });
          }
        });
      });

      // Ordena los campos dentro de los grupos, primero no visual
      side.grupos.forEach((grupo) => {
        grupo.campos.sort(function (a, b) {
          return a.visual - b.visual;
        });
      });

      // Ordena los grupos
      side.grupos.sort((a, b) => a.orden - b.orden);

      // Crea los literales
      side.literales.push(this.CreaLiteral("Izquierda"));
      // Crea perfil o coge el del prop. Sólo se aplica al side izda, el side dcha se queda con el perfil por defecto
      let perfiles;
      perfiles = this.CreaPerfil(side);
      side.perfil = perfiles[0];
      side.perfilRevestimiento = perfiles[1];

      // Se añaden los sides a la colección
      coleccion.sides.push(side);
      coleccion.sides.push(this.CopiaSide(side));
      // Se cambia el código e id
      coleccion.sides[1].cod = "right";
      coleccion.sides[1].id = 1;
      coleccion.sides[1].literales = [];
      coleccion.sides[1].literales.push(this.CreaLiteral("Derecha"));

      aplicacion.datos3Drender = this.datos3Drender;
      aplicacion.datosEstandar = this.datosEstandar;
      aplicacion.datosConfigurable = this.datosConfigurable;

      return aplicacion;
    },
    NuevoGrupo(side, codGrupo) {
      var posicion;
      var grupo = side.grupos.find((grupo) => grupo.cod == codGrupo);

      if (grupo == null) {
        posicion = side.grupos.length * 5 + 10;

        grupo = new Grupo();
        grupo.cod = codGrupo;
        side.grupos.push(grupo);

        var filtro = this.datos3Drender.positions.filter(
          (linea) => linea.grupo == grupo.cod
        );
        grupo.position = new Position();

        if (filtro.length > 0) {
          if (filtro[0][this.codImage.toUpperCase() + ".left"] != undefined) {
            grupo.position.left =
              filtro[0][this.codImage.toUpperCase() + ".left"] * 100 + "%";
          } else {
            grupo.position.left = posicion + "%";
            posicion += 5;
          }
          if (filtro[0][this.codImage.toUpperCase() + ".top"] != undefined) {
            grupo.position.top =
              filtro[0][this.codImage.toUpperCase() + ".top"] * 100 + "%";
          } else {
            grupo.position.top = posicion + "%";
            posicion += 5;
          }
          grupo.position.hotSpot = true;
        } else {
          grupo.position.hotSpot = false;
          // grupo.position.left = posicion + "%";
          // grupo.position.top = posicion + "%";
          // posicion += 5;
        }

        // Busca el literal del grupo en el idioma que llega en el prop
        var texto = this.datos3Drender.gruposTrad
          .filter((trad) => trad.grupo == codGrupo)[0]
          .literales.filter(
            (literal) => literal.codIdioma == this.language
          )[0].texto;

        grupo.orden = this.datos3Drender.gruposTrad.filter(
          (trad) => trad.grupo == codGrupo
        )[0].orden;

        grupo.literales.push(this.CreaLiteral(texto));
      }

      return grupo;
    },
    CreaCamposGrupos(side, campo) {
      var grupo;

      // Filtra aquellos grupos que contienen un include que casa
      var lineas = this.datos3Drender.gruposCampos.filter(
        (linea) =>
          linea.includes.filter((include) => campo.cod.includes(include))
            .length > 0
      );

      // Si encuentra mnás de uno filtra pero es más restrictivo, no usa "includes" usa "=="
      if (lineas.length > 1) {
        lineas = this.datos3Drender.gruposCampos.filter(
          (linea) =>
            linea.includes.filter((include) => campo.cod == include).length > 0
        );
      }

      if (lineas.length == 1) {
        grupo = this.NuevoGrupo(side, lineas[0].grupo);
        campo.visual = lineas[0].visual == "SI";
        campo.visible = true;
      } else if (lineas.length > 1) {
        grupo = this.NuevoGrupo(side, "OTROS");
        campo.visual = true;
        campo.visible = true;
      } else {
        grupo = this.NuevoGrupo(side, "OTROS");
        campo.visual = false;
        campo.visible = true;
      }
      campo.esCapa = campo.visual;
      return grupo;
    },
    CreaRevestimiento(coleccion, grupo) {
      // Recorriendo las filas y columnas
      var campoCod;
      var acabadoCod;
      var campo;
      var acabado;
      var texto;

      for (const row of this.datos3Drender.revestimiento) {
        campoCod = row["campo"];
        acabadoCod = row["acabado"];
        if (campoCod != undefined) {
          // Crea el campo si así lo indica la fila
          campo = new Campo();
          campo.cod = campoCod;
          campo.visual = true;
          campo.esCapa = true;
          campo.condicion = "";
          campo.relacion = "";
          campo.tipo = "tacos";
          campo.visible = true;
          // La etiqueta para la tradudcción es "c" + idioma: "c" de campo
          texto = row["c" + this.language];
          if (texto == undefined) {
            texto = "[" + campo.cod + "]";
          }
          campo.literales.push(this.CreaLiteral(texto));
          grupo.campos.push(campo);
        }
        // Crea el acabado
        acabado = new Acabado();
        acabado.cod = acabadoCod;
        acabado.taco =
          campo.cod + this.separador + acabado.cod + "." + this.extension;
        acabado.condicion = "";
        acabado.relacion = "";
        acabado.capa =
          coleccion.cod.toUpperCase() +
          this.separador +
          grupo.cod +
          this.separador +
          campo.cod +
          this.separador +
          acabado.cod +
          "." +
          this.extension;

        texto = row["a" + this.language];
        if (texto == undefined) {
          texto = "[" + acabado.cod + "]";
        }
        acabado.literales.push(this.CreaLiteral(texto));
        campo.acabados.push(acabado);
        campo.acabadoSel = campo.acabados[1];
      }
    },
    // LOCAL STORAGE Y FAVORITOS
    GetLS() {
      var DarkMode = localStorage.getItem("29395-docciaDarkMode");
      var Hotspots = localStorage.getItem("29395-docciaHotspots");
      if (DarkMode != null) {
        this.SetDarkMode(DarkMode == "true" ? true : false);
      }
      if (Hotspots != null) {
        this.SetHotspots(Hotspots == "true" ? true : false);
      }
    },
    SetLS(key, val) {
      localStorage.setItem("29395-doccia" + key, val);
    },
    SetSave() {
      //console.log("Save as favorite");
    },
    // GLOBALES
    SetVersion() {
      this.Version = this.Zoom ? "4000" : "1000";
    },
    SetType() {
      // Se guarda el código de grupo
      var grupoCod = this.aplicacion.grupoSel.Live.cod;
      // Se guarda el sideSel
      var sideSelCod = this.aplicacion.coleccionSel.sideSel.Live.cod;
      if (this.aplicacion.tipo == "configurable") {
        this.aplicacion = this.aplicacionEstandar;
      } else {
        this.aplicacion = this.aplicacionConfigurable;
      }
      // Pone el grupo en el UI
      this.aplicacion.grupoSel.Live =
        this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(grupoCod);
      this.aplicacion.grupoSel.Delay =
        this.aplicacion.coleccionSel.sideSel.Live.GetGrupo(grupoCod);
      this.SetSide(this.aplicacion.coleccionSel.GetSide(sideSelCod));
      setTimeout(() => {
        this.$root.$emit(
          "DrawImages",
          this.aplicacion,
          this.aplicacion.colecciones[0].sides[0]
        );
        this.$root.$emit(
          "DrawImages",
          this.aplicacion,
          this.aplicacion.colecciones[0].sides[1]
        );
      }, 350);
    },
    SetOpen(Boolean) {
      if (this.Open != Boolean) {
        this.Open = Boolean;
      }
    },
    SetContent(String) {
      if (this.Content != String) {
        this.Content = String;
      }
    },
    SetComparador(Boolean) {
      if (this.Comparador != Boolean) {
        this.Comparador = Boolean;
      }
    },
    // HEADER
    SetShare() {
      if (this.aplicacion.tipo == "estandar") {
        const url = new URL(window.location.href);
        var perfilRevestimientoString = JSON.stringify(
          this.aplicacion.coleccionSel.sideSel.Live.perfilRevestimiento
        );
        perfilRevestimientoString = encodeURIComponent(
          perfilRevestimientoString
        );
        const urlString =
          url.origin +
          url.pathname +
          "?inicial=estandar&idmaterial=" +
          this.aplicacion.GetCodigoEstandar() +
          "&perfilRevestimiento=" +
          perfilRevestimientoString;
        this.$root.$emit("Modal", "Share", urlString);
      } else {
        const url = new URL(window.location.href);

        var perfilString = JSON.stringify(
          this.aplicacion.coleccionSel.sideSel.Live.perfil
        );
        var perfilRevestimientoString = JSON.stringify(
          this.aplicacion.coleccionSel.sideSel.Live.perfilRevestimiento
        );
        perfilString = encodeURIComponent(perfilString);
        perfilRevestimientoString = encodeURIComponent(
          perfilRevestimientoString
        );

        const urlString =
          url.origin +
          url.pathname +
          "?inicial=configurable&perfil=" +
          perfilString +
          "&perfilRevestimiento=" +
          perfilRevestimientoString;

        this.$root.$emit("Modal", "Share", urlString);
      }
    },
    SetDarkMode(Boolean) {
      if (this.DarkMode.Live != Boolean) {
        this.DarkMode.Live = Boolean;
        this.SetLS("DarkMode", Boolean);
        setTimeout(() => {
          this.DarkMode.Delay = Boolean;
        }, 350);
      }
    },
    SetHotspots(Boolean) {
      if (this.Hotspots.Live != Boolean) {
        this.Hotspots.Live = Boolean;
        this.SetLS("Hotspots", Boolean);
        setTimeout(() => {
          this.Hotspots.Delay = Boolean;
        }, 350);
      }
    },
    SetZoom(Boolean) {
      if (this.Zoom != Boolean) {
        this.Zoom = Boolean;
        if (Boolean) {
          document.addEventListener("keydown", this.handleKeyDown);
        } else {
          document.removeEventListener("keydown", this.handleKeyDown);
        }
        this.SetVersion();
      }
    },
    handleKeyDown(event) {
      if (event.code === "Escape") {
        // Set Zoom to false
        this.SetZoom(false);
        document.removeEventListener("keydown", this.handleKeyDown);
      }
    },
    SetView(String) {
      if (this.aplicacion.view != String) {
        var Button;
        if (window.location.href.includes("8081")) {
          Button = document.getElementsByClassName("buttons__item")[6];
        } else {
          Button = document
            .querySelector("c-selector")
            .shadowRoot.querySelectorAll(".buttons__item")[6];
        }
        Button.children[0].children[0].style.opacity = 0;
        Button.children[2].children[0].style.opacity = 0;
        this.aplicacion.view.Live = String;
        setTimeout(() => {
          this.aplicacion.view.Delay = String;
          Button.children[2].children[0].style.opacity = 1;
        }, 350);
      }
    },
    SetFullScreen(Boolean) {
      if (this.FullScreen.Live != Boolean) {
        this.FullScreen.Live = Boolean;
        setTimeout(() => {
          this.FullScreen.Delay = Boolean;
        }, 350);
      }
    },
    SetClose() {
      this.Visible = false;
      document.documentElement.style.overflow = "revert";
      var perfil, idmaterial;
      if (this.aplicacion.tipo == "estandar") {
        perfil = this.aplicacion.coleccionSel.sideSel.Live.perfil;
        idmaterial = this.aplicacion.GetCodigoEstandar();
      } else {
        perfil = this.aplicacion.coleccionSel.sideSel.Live.perfil;
      }

      let miEvento = new CustomEvent("3drender-close", {
        detail: {
          perfil: perfil,
          idmaterial: idmaterial,
        },
      });
      window.dispatchEvent(miEvento);
      setTimeout(() => {
        this.Loading = true;
      }, 350);
    },
    // MENU
    SetGrupo(Object) {
      if (this.Content == "caracteristicas") {
        if (this.aplicacion.grupoSel.Live != Object) {
          var Menu;
          if (window.location.href.includes("8081")) {
            Menu = document.getElementsByClassName(
              "menu__caracteristicas__campos"
            )[0];
          } else {
            Menu = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".menu__caracteristicas__campos");
          }
          this.aplicacion.grupoSel.Live = Object;
          Menu.scrollTop = 0;
          const checkIfScrollToIsFinished = setInterval(() => {
            if (0 === Menu.scrollTop) {
              Menu.style.opacity = 0;
              setTimeout(() => {
                this.aplicacion.grupoSel.Delay = Object;
                Menu.style.opacity = 1;
                //ERROR CHECK
                var CamposError = [];
                setTimeout(() => {
                  if (
                    Object.EsError(
                      this.aplicacion.coleccionSel.sideSel.Live.perfil
                    )
                  ) {
                    var Campos;
                    if (window.location.href.includes("8081")) {
                      Campos = document.getElementsByClassName(
                        "menu__caracteristicas__campos"
                      )[0].children;
                    } else {
                      Campos = document
                        .querySelector("c-selector")
                        .shadowRoot.querySelector(
                          ".menu__caracteristicas__campos"
                        ).children;
                    }
                    for (const Campo of Campos) {
                      if (Campo.getAttribute("error")) {
                        CamposError.push(Campo);
                      }
                    }
                    if (Menu.scrollHeight > Menu.clientHeight) {
                      Menu.scrollTop = CamposError[0].offsetTop;
                      CamposError.forEach((CampoError) => {
                        setTimeout(() => {
                          CampoError.classList.add("pop");
                          setTimeout(() => {
                            CampoError.classList.remove("pop");
                          }, 350);
                        }, 150);
                      });
                    } else {
                      CamposError.forEach((CampoError) => {
                        setTimeout(() => {
                          CampoError.classList.add("pop");
                          setTimeout(() => {
                            CampoError.classList.remove("pop");
                          }, 350);
                        }, 150);
                      });
                    }
                  }
                }, 350);
              }, 350);
              clearInterval(checkIfScrollToIsFinished);
            }
          }, 25);
        }
      } else {
        this.aplicacion.grupoSel.Live = Object;
        this.aplicacion.grupoSel.Delay = Object;
        this.SetContent("caracteristicas");
        if (!this.Open) {
          this.SetOpen(true);
        }
        setTimeout(() => {
          var Menu;
          if (window.location.href.includes("8081")) {
            Menu = document.getElementsByClassName(
              "menu__caracteristicas__campos"
            )[0];
          } else {
            Menu = document
              .querySelector("c-selector")
              .shadowRoot.querySelector(".menu__caracteristicas__campos");
          }
          var CamposError = [];
          setTimeout(() => {
            if (
              Object.EsError(this.aplicacion.coleccionSel.sideSel.Live.perfil)
            ) {
              var Campos;
              if (window.location.href.includes("8081")) {
                Campos = document.getElementsByClassName(
                  "menu__caracteristicas__campos"
                )[0].children;
              } else {
                Campos = document
                  .querySelector("c-selector")
                  .shadowRoot.querySelector(
                    ".menu__caracteristicas__campos"
                  ).children;
              }
              for (const Campo of Campos) {
                if (Campo.getAttribute("error")) {
                  CamposError.push(Campo);
                }
              }
              if (Menu.scrollHeight > Menu.clientHeight) {
                Menu.scrollTop = CamposError[0].offsetTop;
                CamposError.forEach((CampoError) => {
                  setTimeout(() => {
                    CampoError.classList.add("pop");
                    setTimeout(() => {
                      CampoError.classList.remove("pop");
                    }, 350);
                  }, 150);
                });
              } else {
                CamposError.forEach((CampoError) => {
                  setTimeout(() => {
                    CampoError.classList.add("pop");
                    setTimeout(() => {
                      CampoError.classList.remove("pop");
                    }, 350);
                  }, 150);
                });
              }
            }
          }, 350);
        }, 350);
      }
    },
    SetFiltro(CampoObject, FiltroObject) {
      var coleccion = this.aplicacion.coleccionSel;
      var campo = coleccion.sideSel.Live.GetCampo(CampoObject.cod);
      var filtro = campo.GetFiltro(FiltroObject.cod);
      //var acabado = campo.GetAcabado(AcabadoObject.cod);
      var decorados;
      if (window.location.href.includes("8081")) {
        decorados = document.getElementsByClassName(
          "menu__caracteristicas__campos__item__compuesto__items"
        )[0];
      } else {
        decorados = document
          .querySelector("c-selector")
          .shadowRoot.querySelectorAll(
            ".menu__caracteristicas__campos__item__compuesto__items"
          )[0];
      }
      decorados.style.opacity = 0;
      campo.filtroSel.Live = filtro;
      setTimeout(() => {
        campo.filtroSel.Delay = filtro;
        decorados.style.opacity = 1;
      }, 350);
      //CampoObject.filtroSel = FiltroObject;
      campo.acabadoSel = campo.GetAcabado(FiltroObject.cod);
      this.SetPerfil(null, CampoObject.cod.toLowerCase(), FiltroObject.cod);
    },
    SetAcabado(GrupoObject, CampoObject, AcabadoObject) {
      //console.log("Llega el emit", GrupoObject, CampoObject, AcabadoObject);
      if (CampoObject.tipo == "input") {
        this.SetPerfil(
          GrupoObject.cod,
          CampoObject.cod.toLowerCase(),
          CampoObject.value
        );
      } else {
        var coleccion = this.aplicacion.coleccionSel;
        var campo = coleccion.sideSel.Live.GetCampo(CampoObject.cod);
        var acabado = campo.GetAcabado(AcabadoObject.cod);

        // Se asigna el acabado
        campo.acabadoSel = acabado;

        // Se actualiza perfil
        this.SetPerfil(
          GrupoObject.cod,
          CampoObject.cod.toLowerCase(),
          CampoObject.acabadoSel.cod
        );

        if (CampoObject.visual) {
          this.$root.$emit(
            "DrawImages",
            this.aplicacion,
            this.aplicacion.coleccionSel.sideSel.Live
          );
        }
      }
    },
    SetAcabadoCompuesto(CampoObject, FiltroObject, AcabadoObject) {
      var coleccion = this.aplicacion.coleccionSel;
      var campo = coleccion.sideSel.Live.GetCampo(CampoObject.cod);
      var filtro = campo.GetFiltro(FiltroObject.cod);
      var acabado = filtro.GetAcabado(AcabadoObject.cod);

      filtro.acabadoSel = acabado;

      CampoObject.filtros.forEach((filtro) => {
        filtro.acabadoSel = filtro.GetAcabado(AcabadoObject.cod);
      });
      var campo2 =
        this.aplicacion.coleccionSel.sideSel.Live.GetCampo("DECORADO");
      campo2.acabadoSel = campo2.GetAcabado(AcabadoObject.cod);

      this.SetPerfil(null, "decorado", AcabadoObject.cod);
      this.$root.$emit(
        "DrawImages",
        this.aplicacion,
        this.aplicacion.coleccionSel.sideSel.Live
      );
    },
    SetPerfil(grupo, campo, value) {
      var perfil = this.aplicacion.coleccionSel.sideSel.Live.perfil;
      var perfilRevestimiento =
        this.aplicacion.coleccionSel.sideSel.Live.perfilRevestimiento;

      //console.log("antes", perfil);

      if (grupo == "REVESTIMIENTO") {
        if (perfilRevestimiento[campo] != undefined) {
          perfilRevestimiento[campo].value = value;
        }
      } else {
        //console.log("Set perfil", campo);
        //console.log(perfil);

        if (perfil[campo] != undefined) {
          perfil[campo].value = value;
        } else {
          // Modifica el objeto y añade el watcher a perfil
          this.$set(perfil, campo, { value: value });
          //console.log("Añadiendo caracterísitica " + campo + " en el perfil");
        }
      }
    },
    GetDatos3Drender() {
      var that = this;
      var url = "/Files/DATOS3DRENDER.xlsx";

      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          const reader = new FileReader();
          reader.readAsBinaryString(res.data);
          reader.onload = (e) => {
            var element;
            if (e.target == null || e.target == undefined) {
              element = e.path[0];
            } else {
              element = e.target;
            }
            var data = element.result;
            var workbook = XLSX.read(data, { type: "binary" });

            // Colecciones
            var sheet = XLSX.utils.sheet_to_json(
              workbook.Sheets["COLECCIONES"]
            );
            that.datos3Drender.colecciones = sheet;

            // Idiomas
            var sheet = XLSX.utils.sheet_to_json(workbook.Sheets["LANGUAGE"]);
            that.datos3Drender.language = sheet;
            // Fija el idioma de la app
            that.language = that.datos3Drender.language[0][that.locale];

            // Creación de grupos y campos asignados
            var sheet = XLSX.utils.sheet_to_json(
              workbook.Sheets["GRUPOS&CAMPOS"]
            );

            var cellValue;
            that.datos3Drender.gruposCampos = [];
            // Recorriendo las filas y columnas
            for (const row of sheet) {
              var linea = {};
              linea.grupo = row["grupo"];
              linea.visual = row["visual"];
              linea.includes = [];

              // Recorriendo las columnas dentro de cada fila
              for (const column in row) {
                cellValue = row[column];
                if (column.includes("includes")) {
                  // Son los includes
                  linea.includes.push(cellValue);
                }
              }
              that.datos3Drender.gruposCampos.push(linea);
            }

            // Traducción de grupos
            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["GRUPOS&TRAD"]);
            that.datos3Drender.gruposTrad = [];
            // Recorriendo las filas y columnas
            for (const row of sheet) {
              linea = {};
              linea.grupo = row["grupo"];
              linea.orden = row["orden"];
              linea.literales = [];
              // Recorriendo las columnas dentro de cada fila
              for (const column in row) {
                cellValue = row[column];
                if (column != "grupo") {
                  // Es una traducción
                  linea.literales.push(
                    this.CreaLiteralIdioma(column, cellValue)
                  );
                }
              }
              if (linea.literales.length <= 0) {
                linea.literales.push(this.CreaLiteral("[" + linea.grupo + "]"));
              }
              that.datos3Drender.gruposTrad.push(linea);
            }

            // Grupo revestimiento
            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["REVESTIMIENTO"]);
            that.datos3Drender.revestimiento = sheet;

            // Posicion de los HotSpots
            let idclase = this.idclase.toUpperCase();

            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["POSITIONS"]);
            that.datos3Drender.positions = sheet;
            //var posicion = 10;
            // sheet.forEach((fila) => {
            //   if (fila[idclase + ".left"] != undefined) {
            //     that.datos3Drender.positions.push({
            //       grupo: fila.grupo,
            //       left: fila[idclase + ".left"] * 100 + "%",
            //       top: fila[idclase + ".top"] * 100 + "%",
            //     });
            //   } else {
            //     that.datos3Drender.positions.push({
            //       grupo: fila.grupo,
            //       left: posicion + "%",
            //       top: posicion + "%",
            //     });
            //     posicion += 5;
            //   }
            // });
            // Posicion de la escena
            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["OBJECTPOSITION"]);
            that.datos3Drender.objectPosition = sheet;

            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["ESTANDAR"]);
            that.datos3Drender.estandar = sheet;

            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["TIPO&CAMPO"]);
            that.datos3Drender.tipoCampo = sheet;

            //console.log("3DRENDER EXCEL", that.datos3Drender);
          };
        })
        .catch((error) => {
          //console.log(error);
          if (error.response) {
          } else if (error.request) {
          } else {
            // Error en la solicitud (por ejemplo, error de configuración de axios)
          }
        });
    },
  },
};
</script>

<style lang="scss">
.app {
  font-family: Poppins, sans-serif;
  position: fixed;
  z-index: 1000;
  opacity: 1;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
  background-color: white;
  -webkit-transition: opacity 0.35s ease-in-out;
  -moz-transition: opacity 0.35s ease-in-out;
  -ms-transition: opacity 0.35s ease-in-out;
  -o-transition: opacity 0.35s ease-in-out;
  transition: opacity 0.35s ease-in-out;

  &__selector {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: white;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;

    &__header {
      width: 100%;
      height: $Header-height;
    }

    &__content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: calc(100% - $Header-height);

      &__canvas {
        opacity: 1 !important;
        -webkit-transition: all 0.35s ease-in-out !important;
        -moz-transition: all 0.35s ease-in-out !important;
        -ms-transition: all 0.35s ease-in-out !important;
        -o-transition: all 0.35s ease-in-out !important;
        transition: all 0.35s ease-in-out !important;

        &.hidden {
          opacity: 0 !important;
          -webkit-transition: all 0.35s ease-in-out !important;
          -moz-transition: all 0.35s ease-in-out !important;
          -ms-transition: all 0.35s ease-in-out !important;
          -o-transition: all 0.35s ease-in-out !important;
          transition: all 0.35s ease-in-out !important;
        }
      }

      &__pano {
        opacity: 1 !important;
        -webkit-transition: all 0.35s ease-in-out !important;
        -moz-transition: all 0.35s ease-in-out !important;
        -ms-transition: all 0.35s ease-in-out !important;
        -o-transition: all 0.35s ease-in-out !important;
        transition: all 0.35s ease-in-out !important;

        &.hidden {
          opacity: 0 !important;
          -webkit-transition: all 0.35s ease-in-out !important;
          -moz-transition: all 0.35s ease-in-out !important;
          -ms-transition: all 0.35s ease-in-out !important;
          -o-transition: all 0.35s ease-in-out !important;
          transition: all 0.35s ease-in-out !important;
        }
      }
    }

    &.dark {
      background-color: #333333;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;

      ::selection {
        background: rgba(255, 255, 255, 0.4);
      }

      ::-moz-selection {
        background: rgba(255, 255, 255, 0.4);
      }

      & .buttons__item {
        &:nth-child(1) {
          & .buttons__item {
            &__miniatura {
              &__image {
                filter: invert(50%) !important;
              }
            }
          }
        }
      }

      & .modal {
        filter: invert(100%);
        background-color: rgb(255, 255, 255, 0.7);

        &__option {
          &__item {
            filter: invert(100%);
          }
        }

        &__image {
          &__item {
            filter: invert(100%);
          }
        }

        &__share {
          filter: invert(100%);
          background-color: #333333;
        }
      }

      & .header {
        background-color: #000000;
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;

        &__info {
          &__logo {
            filter: invert(100%) brightness(0.85);
            -webkit-transition: filter 0.35s ease-in-out;
            -moz-transition: filter 0.35s ease-in-out;
            -ms-transition: filter 0.35s ease-in-out;
            -o-transition: filter 0.35s ease-in-out;
            transition: filter 0.35s ease-in-out;
          }

          &__collection {
            color: white;
            -webkit-transition: color 0.35s ease-in-out;
            -moz-transition: color 0.35s ease-in-out;
            -ms-transition: color 0.35s ease-in-out;
            -o-transition: color 0.35s ease-in-out;
            transition: color 0.35s ease-in-out;
          }

          &__separator {
            background-color: white;
            -webkit-transition: background-color 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out;
          }
        }

        &__menu {
          &__option {
            &__items {
              &__item {
                &__option {
                  &__image {
                    filter: invert(100%);
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }

                  &__name {
                    filter: invert(100%);
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }
                }
              }
            }

            &__save {
              &__name {
                filter: invert(100%);
                -webkit-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  filter 0.35s ease-in-out;
                transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              }
            }

            &__icon {
              filter: invert(100%);
              -webkit-transition: filter 0.35s ease-in-out;
              -moz-transition: filter 0.35s ease-in-out;
              -ms-transition: filter 0.35s ease-in-out;
              -o-transition: filter 0.35s ease-in-out;
              transition: filter 0.35s ease-in-out;
            }

            &__exit {
              filter: invert(100%);
              -webkit-transition: filter 0.35s ease-in-out;
              -moz-transition: filter 0.35s ease-in-out;
              -ms-transition: filter 0.35s ease-in-out;
              -o-transition: filter 0.35s ease-in-out;
              transition: filter 0.35s ease-in-out;
            }
          }

          &__separator {
            background-color: white;
            -webkit-transition: background-color 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out;
          }
        }
      }

      & .pricing {
        background-color: rgba(0, 0, 0, 0.65);
        -webkit-transition: opacity 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -moz-transition: opacity 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -ms-transition: opacity 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -o-transition: opacity 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        transition: opacity 0.35s ease-in-out,
          background-color 0.35s ease-in-out;

        &__container {
          color: white;
          -webkit-transition: color 0.35s ease-in-out;
          -moz-transition: color 0.35s ease-in-out;
          -ms-transition: color 0.35s ease-in-out;
          -o-transition: color 0.35s ease-in-out;
          transition: color 0.35s ease-in-out;

          &__value {
            &__loader {
              filter: invert(100%);
              -webkit-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -moz-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -ms-transition: opacity 0.35s ease-in-out,
                filter 0.35s ease-in-out;
              -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
              transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            }
          }

          &__type {
            &__envio {
              &__time {
                &__loader {
                  filter: invert(100%);
                  -webkit-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out,
                    filter 0.35s ease-in-out;
                }
              }
            }
          }
        }

        &__buy {
          border: 1px solid white;
          -webkit-transition: opacity 0.35s ease-in-out,
            0.35s ease-in-out border;
          -moz-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
          -ms-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
          -o-transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
          transition: opacity 0.35s ease-in-out, 0.35s ease-in-out border;
        }
      }

      & .canvas {
        &__loader {
          filter: invert(100%);
          -webkit-transition: opacity 0.35s ease-in-out,
            filter 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        }
      }

      & .pano {
        &__loader {
          filter: invert(100%);
          -webkit-transition: opacity 0.35s ease-in-out,
            filter 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
        }
      }

      & .buttons {
        &__item {
          &__miniatura {
            background-color: #333333;
            -webkit-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out,
              opacity 0.35s ease-in-out;

            &__image {
              filter: invert(100%) brightness(50%);
              -webkit-transition: filter 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              -moz-transition: filter 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              -ms-transition: filter 0.35s ease-in-out,
                opacity 0.35s ease-in-out;
              -o-transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
              transition: filter 0.35s ease-in-out, opacity 0.35s ease-in-out;
            }
          }

          &__text {
            filter: invert(100%);
            -webkit-transition: opacity 0.35s ease-in-out,
              filter 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          }

          &.active {
            & .buttons__item {
              &__miniatura {
                &__image {
                  filter: invert(100%) brightness(100%);
                  -webkit-transition: filter 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -moz-transition: filter 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -ms-transition: filter 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  -o-transition: filter 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                  transition: filter 0.35s ease-in-out,
                    opacity 0.35s ease-in-out;
                }
              }
            }
          }

          &:nth-child(7) {
            & .buttons__item {
              &__miniatura {
                &__image {
                  filter: invert(50%) !important;
                }
              }
            }
          }

          &.detalles {
            & .buttons__item {
              &__options {
                &__item {
                  &__miniatura {
                    background-color: #333333;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;

                    &__image {
                      filter: invert(100%);
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;
                    }
                  }

                  &__text {
                    color: black;
                    background-color: white;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }
            }
          }
        }
      }

      & .menu {
        background-color: #333333;
        -webkit-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -moz-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -ms-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -o-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;

        &__caracteristicas {
          background-color: #333333;
          -webkit-transition: background-color 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out;

          &__tipos {
            &__title {
              color: white;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &__items {
              &__item {
                color: white;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;

                &:not(.active):first-child {
                  border-top: 1px solid white;
                  border-left: 1px solid white;
                  border-bottom: 1px solid white;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }

                &:not(.active):last-child {
                  border-top: 1px solid white;
                  border-right: 1px solid white;
                  border-bottom: 1px solid white;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
            }
          }

          &__grupos {
            &__item {
              &__grupo {
                color: rgb(150, 150, 150);
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;

                &__name {
                  &__texto {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }
                }

                &__expand {
                  filter: invert(100%) brightness(50%);
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }

              &__separator {
                background-color: rgb(150, 150, 150);
                -webkit-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
              }
            }

            &__separator {
              background-color: white;
              -webkit-transition: background-color 0.35s ease-in-out;
              -moz-transition: background-color 0.35s ease-in-out;
              -ms-transition: background-color 0.35s ease-in-out;
              -o-transition: background-color 0.35s ease-in-out;
              transition: background-color 0.35s ease-in-out;
            }
          }

          &__campos {
            &__item {
              &__acabados {
                &__title {
                  &__text {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }

                  &__ayuda {
                    &__info {
                      filter: invert(100%);
                      -webkit-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                    }

                    &__text {
                      border: 1px solid white;
                      background-color: #696969;
                      -webkit-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                    }
                  }
                }

                &__items {
                  &__item {
                    &__miniatura {
                      &__image {
                      }

                      &__error {
                        &__texto {
                          color: white;
                          -webkit-transition: color 0.35s ease-in-out;
                          -moz-transition: color 0.35s ease-in-out;
                          -ms-transition: color 0.35s ease-in-out;
                          -o-transition: color 0.35s ease-in-out;
                          transition: color 0.35s ease-in-out;
                        }
                      }
                    }

                    &__name {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }

                    &.active {
                      &
                        .menu__caracteristicas__campos__item__acabados__items__item {
                        &__miniatura {
                          border: 1px solid white;
                          -webkit-transition: all 0.35s ease-in-out;
                          -moz-transition: all 0.35s ease-in-out;
                          -ms-transition: all 0.35s ease-in-out;
                          -o-transition: all 0.35s ease-in-out;
                          transition: all 0.35s ease-in-out;
                        }
                      }
                    }

                    &:not(.active) {
                      &
                        .menu__caracteristicas__campos__item__acabados__items__item {
                        &__miniatura:hover {
                          border: 1px solid rgb(150, 150, 150, 0.7);
                          -webkit-transition: all 0.35s ease-in-out;
                          -moz-transition: all 0.35s ease-in-out;
                          -ms-transition: all 0.35s ease-in-out;
                          -o-transition: all 0.35s ease-in-out;
                          transition: all 0.35s ease-in-out;
                        }
                      }
                    }
                  }
                }
              }

              &__compuesto {
                &__title {
                  &__text {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }

                  &__ayuda {
                    &__info {
                      filter: invert(100%);
                      -webkit-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                    }

                    &__text {
                      border: 1px solid white;
                      background-color: #696969;
                      -webkit-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                    }
                  }
                }

                &__filtros {
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  align-content: center;
                  margin-bottom: 15px;
                  width: 100%;
                  height: 35px;

                  &__item {
                    color: white;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;

                    &:not(.active):first-child {
                      border-top: 1px solid white;
                      border-left: 1px solid white;
                      border-bottom: 1px solid white;
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;
                    }

                    &:not(.active):last-child {
                      border-top: 1px solid white;
                      border-right: 1px solid white;
                      border-bottom: 1px solid white;
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;
                    }
                  }
                }

                &__items {
                  &__item {
                    &__miniatura {
                      &__image {
                      }

                      &__error {
                        &__texto {
                          color: white;
                          -webkit-transition: color 0.35s ease-in-out;
                          -moz-transition: color 0.35s ease-in-out;
                          -ms-transition: color 0.35s ease-in-out;
                          -o-transition: color 0.35s ease-in-out;
                          transition: color 0.35s ease-in-out;
                        }
                      }
                    }

                    &__name {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }

                    &.active {
                      &
                        .menu__caracteristicas__campos__item__compuesto__items__item {
                        &__miniatura {
                          border: 1px solid white;
                          -webkit-transition: all 0.35s ease-in-out;
                          -moz-transition: all 0.35s ease-in-out;
                          -ms-transition: all 0.35s ease-in-out;
                          -o-transition: all 0.35s ease-in-out;
                          transition: all 0.35s ease-in-out;
                        }
                      }
                    }

                    &:not(.active) {
                      &
                        .menu__caracteristicas__campos__item__compuesto__items__item {
                        &__miniatura:hover {
                          border: 1px solid rgb(150, 150, 150, 0.7);
                          -webkit-transition: all 0.35s ease-in-out;
                          -moz-transition: all 0.35s ease-in-out;
                          -ms-transition: all 0.35s ease-in-out;
                          -o-transition: all 0.35s ease-in-out;
                          transition: all 0.35s ease-in-out;
                        }
                      }
                    }
                  }
                }
              }

              &__dropdown {
                &__title {
                  &__text {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }

                  &__ayuda {
                    &__info {
                      filter: invert(100%);
                      -webkit-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                    }

                    &__text {
                      border: 1px solid white;
                      background-color: #696969;
                      -webkit-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                    }
                  }
                }

                &__item {
                  &__selected {
                    border: 1px solid rgb(150, 150, 150);
                    background-color: black;
                    color: white;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;

                    &__value {
                    }

                    &__expand {
                      filter: invert(100%);
                      -webkit-transition: filter 0.35s ease-in-out,
                        transform 0.35s ease-in-out;
                      -moz-transition: filter 0.35s ease-in-out,
                        transform 0.35s ease-in-out;
                      -ms-transition: filter 0.35s ease-in-out,
                        transform 0.35s ease-in-out;
                      -o-transition: filter 0.35s ease-in-out,
                        transform 0.35s ease-in-out;
                      transition: filter 0.35s ease-in-out,
                        transform 0.35s ease-in-out;
                    }
                  }

                  &__values {
                    border: 1px solid rgb(150, 150, 150);
                    background-color: black;
                    -webkit-transition: opacity 0.35s ease-in-out,
                      top 0.35s ease-in-out, color 0.35s ease-in-out,
                      border 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      top 0.35s ease-in-out, color 0.35s ease-in-out,
                      border 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      top 0.35s ease-in-out, color 0.35s ease-in-out,
                      border 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      top 0.35s ease-in-out, color 0.35s ease-in-out,
                      border 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                      color 0.35s ease-in-out, border 0.35s ease-in-out,
                      background-color 0.35s ease-in-out;

                    &__item {
                      color: white;
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;

                      &:not(.active):hover {
                        background-color: rgb(100, 100, 100);
                        -webkit-transition: all 0.35s ease-in-out;
                        -moz-transition: all 0.35s ease-in-out;
                        -ms-transition: all 0.35s ease-in-out;
                        -o-transition: all 0.35s ease-in-out;
                        transition: all 0.35s ease-in-out;
                      }
                    }
                  }

                  &:not(.open):hover {
                    & .menu__caracteristicas__campos__item__dropdown__item {
                      &__selected {
                        background-color: rgb(100, 100, 100);
                        -webkit-transition: all 0.35s ease-in-out;
                        -moz-transition: all 0.35s ease-in-out;
                        -ms-transition: all 0.35s ease-in-out;
                        -o-transition: all 0.35s ease-in-out;
                        transition: all 0.35s ease-in-out;
                      }
                    }
                  }
                }
              }

              &__input {
                &__title {
                  &__text {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }

                  &__ayuda {
                    &__info {
                      filter: invert(100%);
                      -webkit-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                    }

                    &__text {
                      border: 1px solid white;
                      background-color: #696969;
                      -webkit-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                    }
                  }
                }

                &__items {
                  &__item {
                    border: 1px solid rgb(150, 150, 150);
                    background-color: black;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;

                    &__input {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }

                    &__unit {
                      color: white;
                      border-left: 1px solid white;
                      -webkit-transition: color 0.35s ease-in-out,
                        border-left 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out,
                        border-left 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out,
                        border-left 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out,
                        border-left 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out,
                        border-left 0.35s ease-in-out;
                    }
                  }
                }
              }

              &__toggle {
                &__title {
                  &__text {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }

                  &__ayuda {
                    &__info {
                      filter: invert(100%);
                      -webkit-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        filter 0.35s ease-in-out;
                    }

                    &__text {
                      border: 1px solid white;
                      background-color: #696969;
                      -webkit-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -moz-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -ms-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      -o-transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                      transition: opacity 0.35s ease-in-out,
                        border 0.35s ease-in-out;
                    }
                  }
                }
              }
            }
          }
        }

        &__grupos {
          background-color: #333333;
          -webkit-transition: background-color 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out;

          &__tipos {
            border-top: 1px solid white;
            border-bottom: 1px solid white;
            -webkit-transition: all 0.35s ease-in-out;
            -moz-transition: all 0.35s ease-in-out;
            -ms-transition: all 0.35s ease-in-out;
            -o-transition: all 0.35s ease-in-out;
            transition: all 0.35s ease-in-out;

            &__items {
              &__item {
                color: white;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
          }

          &__item {
            &__error {
            }

            &__text {
              color: white;
              -webkit-transition: color 0.35s ease-in-out;
              -moz-transition: color 0.35s ease-in-out;
              -ms-transition: color 0.35s ease-in-out;
              -o-transition: color 0.35s ease-in-out;
              transition: color 0.35s ease-in-out;
            }

            &:not(:last-child) {
              border-bottom: 1px solid white;
              -webkit-transition: border-bottom 0.35s ease-in-out;
              -moz-transition: border-bottom 0.35s ease-in-out;
              -ms-transition: border-bottom 0.35s ease-in-out;
              -o-transition: border-bottom 0.35s ease-in-out;
              transition: border-bottom 0.35s ease-in-out;
            }
          }
        }

        &__resumen {
          background-color: #333333;
          -webkit-transition: background-color 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out;

          &__top {
            &__title {
              color: white;
              border-bottom: 1px solid rgb(150, 150, 150);
              -webkit-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              -moz-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              -ms-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              -o-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
            }
          }

          &__grupos {
            &__item {
              border-bottom: 1px solid rgb(150, 150, 150);
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &__title {
                color: white;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }

              &__campos {
                &__item {
                  &__title {
                    &__campo {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }

                    &__value {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }
                  }

                  &__miniatura {
                    &__image {
                    }
                  }

                  &__value {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }
                }
              }
            }
          }

          &__bottom {
            &__buy {
            }
          }
        }
      }

      & .skeleton {
        background-image: url("@/assets/Images/Global/Loaderwh.svg") !important;
        -webkit-transition: all 0.35s ease-in-out;
        -moz-transition: all 0.35s ease-in-out;
        -ms-transition: all 0.35s ease-in-out;
        -o-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
      }
    }
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;
  }

  @media screen and (max-width: 950px) and (min-height: 600px) {
    &__selector {
      &__content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
      }

      &.dark {
        & .header {
          &__menu {
            &__option {
              &__items {
                &__item {
                  background-color: #333333;
                  -webkit-transition: background-color 0.35s ease-in-out;
                  -moz-transition: background-color 0.35s ease-in-out;
                  -ms-transition: background-color 0.35s ease-in-out;
                  -o-transition: background-color 0.35s ease-in-out;
                  transition: background-color 0.35s ease-in-out;
                }
              }
            }
          }
        }

        & .pricing {
          background-color: rgba(0, 0, 0);
          -webkit-transition: opacity 0.35s ease-in-out,
            background-color 0.35s ease-in-out;
          -moz-transition: opacity 0.35s ease-in-out,
            background-color 0.35s ease-in-out;
          -ms-transition: opacity 0.35s ease-in-out,
            background-color 0.35s ease-in-out;
          -o-transition: opacity 0.35s ease-in-out,
            background-color 0.35s ease-in-out;
          transition: opacity 0.35s ease-in-out,
            background-color 0.35s ease-in-out;
        }

        & .buttons {
          &__item {
            background-color: #333333;
            -webkit-transition: background-color 0.35s ease-in-out,
              height 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out,
              height 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out,
              height 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out,
              height 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out,
              height 0.35s ease-in-out;

            &.active {
              background-color: black;
              -webkit-transition: background-color 0.35s ease-in-out,
                height 0.35s ease-in-out;
              -moz-transition: background-color 0.35s ease-in-out,
                height 0.35s ease-in-out;
              -ms-transition: background-color 0.35s ease-in-out,
                height 0.35s ease-in-out;
              -o-transition: background-color 0.35s ease-in-out,
                height 0.35s ease-in-out;
              transition: background-color 0.35s ease-in-out,
                height 0.35s ease-in-out;

              &:nth-child(7) {
                background-color: black;
              }
            }

            &:nth-child(7) {
              background-color: #333333;
            }
          }
        }

        & .menu {
          -webkit-transition: margin-bottom 0.35s ease-in-out;
          -moz-transition: margin-bottom 0.35s ease-in-out;
          -ms-transition: margin-bottom 0.35s ease-in-out;
          -o-transition: margin-bottom 0.35s ease-in-out;
          transition: margin-bottom 0.35s ease-in-out;

          &__resumen {
            &__grupos {
              &__item {
                &:last-child {
                  border-bottom: none;
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-height: 600px) {
    &__selector {
      &.dark {
        & .buttons {
          &__item {
            background-color: #333333;
            -webkit-transition: background-color 0.35s ease-in-out,
              width 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out,
              width 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out,
              width 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out,
              width 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out,
              width 0.35s ease-in-out;

            &.active {
              background-color: black;
              -webkit-transition: background-color 0.35s ease-in-out,
                width 0.35s ease-in-out;
              -moz-transition: background-color 0.35s ease-in-out,
                width 0.35s ease-in-out;
              -ms-transition: background-color 0.35s ease-in-out,
                width 0.35s ease-in-out;
              -o-transition: background-color 0.35s ease-in-out,
                width 0.35s ease-in-out;
              transition: background-color 0.35s ease-in-out,
                width 0.35s ease-in-out;
            }

            &:nth-child(7) {
              background-color: black;
            }

            &:last-child {
              -webkit-transition: all 0.35s ease-in-out;
              -moz-transition: all 0.35s ease-in-out;
              -ms-transition: all 0.35s ease-in-out;
              -o-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }

            &.detalles {
              & .buttons__item {
                &__options {
                  &__item {
                    background-color: #333333;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                  }
                }
              }
            }
          }
        }

        & .menu {
          &__grupos {
            &__tipos {
              border-top: 1px solid transparent;
            }
          }
        }
      }
    }
  }
}
</style>
